import { JanglCheckboxController as controller } from './controller.js';
import templateUrl from './template.html';

export const janglCheckboxComponent = {
    templateUrl: templateUrl,
    controller: controller,
    transclude: true,
    bindings: {
        // pass in a refernce to the form for the parent for validation.
        form: '=',
        // model to bind
        model: '=',
        // element name
        name: '@',
        // whether the field should be required
        required: '<'
    }
};



// WEBPACK FOOTER //
// ./app/jangl/jangl-checkbox/component.js